"use client";

import { useEffect, useState } from "react";

// Boot splash that paints from the very first SSR'd HTML byte, then hands off
// to React. CRITICAL: the element is owned by React end-to-end — never use
// raw `removeChild` here. Doing so corrupts React's sibling references and
// breaks subsequent navigations with "insertBefore" errors.
export function BootSplash() {
  const [hidden, setHidden] = useState(false);
  const [removed, setRemoved] = useState(false);

  useEffect(() => {
    // Two rAFs after mount → first real paint is on screen → start fade.
    let raf2 = 0;
    const raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => setHidden(true));
    });
    // Drop from the tree after the fade so it doesn't intercept anything.
    const t = window.setTimeout(() => setRemoved(true), 600);
    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
      window.clearTimeout(t);
    };
  }, []);

  if (removed) return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483647,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        opacity: hidden ? 0 : 1,
        pointerEvents: hidden ? "none" : "auto",
        transition: "opacity .25s ease",
      }}
    >
      <svg
        width={96}
        height={96}
        viewBox="0 0 512 512"
        style={{ animation: "bootPulse 1.4s ease-in-out infinite" }}
      >
        <g stroke="#465fff" strokeWidth={14} strokeLinecap="round" fill="none" opacity={0.55}>
          <path d="M210 96 q-16 22 0 44 q16 22 0 44" />
          <path d="M256 76 q-16 24 0 48 q16 24 0 48" />
          <path d="M302 96 q-16 22 0 44 q16 22 0 44" />
        </g>
        <g fill="#465fff">
          <circle cx={256} cy={226} r={20} />
          <path d="M76 386 Q76 244 256 244 Q436 244 436 386 Z" />
          <rect x={56} y={382} width={400} height={40} rx={20} />
        </g>
      </svg>
    </div>
  );
}
